module.exports = __webpack_public_path__ + "img/qxxh2.1b5628ad.png";